import { render, staticRenderFns } from "./IconGripHorizontal.vue?vue&type=template&id=1f859ea3&"
import script from "./IconGripHorizontal.vue?vue&type=script&lang=ts&"
export * from "./IconGripHorizontal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports